import { api } from '../utils/apiHelpers';
import {
  creditCardDtoToPaymentMethod,
  invoicesLegacyDtoToPaymentMethods,
  invoicesTransporterDtoToPaymentMethods,
  userWalletConfigDtoToModel
} from './transformers/payments';
import {
  CreateWalletInvoiceRequest,
  WalletInvoiceResponse,
  CreditCardsDto,
  InvoicesLegacyDto,
  UserWalletConfigDto
} from './models/payments';
import { sagwClient } from './clients';
import { dtoToMerchantConfig } from './transformers/configs';
import { SetDefaultPaymentMethodDto, SetPaymentMethodsDto, SetSecondaryPaymentMethodDto } from './dtos/payments';
import { MerchantConfigDTO } from './dtos/configs';

export function fetchUserInvoices() {
  return api.get<InvoicesLegacyDto>('/v1/payments/invoices').then(invoicesLegacyDtoToPaymentMethods);
}

export function fetchUserInvoicesTransporter() {
  return sagwClient.get('/mot/user/payment/options/invoice').then(invoicesTransporterDtoToPaymentMethods);
}

export function fetchUserCreditCards() {
  return api.get<CreditCardsDto>('/v1/payments/cards').then(creditCardDtoToPaymentMethod);
}

export function createUserWalletInvoice(requestBody: CreateWalletInvoiceRequest) {
  return sagwClient.post<WalletInvoiceResponse>('/b2b/wallet/invoice', requestBody);
}

export function fetchUserWalletInvoice(invoiceId: string) {
  return sagwClient.get<WalletInvoiceResponse>(`/b2b/wallet/invoice/${invoiceId}`);
}

export function fetchUserWalletConfig() {
  return sagwClient.get<UserWalletConfigDto>('/mot/user/configs/wallet').then(userWalletConfigDtoToModel);
}

export function setDefaultPaymentMethodUDS(requestBody: SetDefaultPaymentMethodDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}

export function setSecondaryPaymentMethodUDS(requestBody: SetSecondaryPaymentMethodDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}

export function setPaymentMethodsUDS(requestBody: SetPaymentMethodsDto) {
  return sagwClient.patch<MerchantConfigDTO>('/mot/merchants/current/payments', requestBody).then(dtoToMerchantConfig);
}
